import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import loanFormModel from '../../../../../../../components/loan_application/form_models/loanFormModel';
import { RulesetResult } from '../../business/rules';
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import PrincipalRentRuleset from '../../business/ruleset/PrincipalRentRuleset';

const {
  formField: { principalRent },
} = loanFormModel;

export class PrincipalRentValidation implements ValidationSchema {
  public name = principalRent.name;
  public label = principalRent.label;
  public type = 'number';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;

  public ruleset = PrincipalRentRuleset;

  public when(schema: any, ...args: any[]) {
    return schema.test({
      name: 'principalRentValidation',
      test: function (value, context) {
        const application: Partial<ApplicationFormValues> = this.from[1].value;

        const result: RulesetResult = PrincipalRentRuleset.setPrincipalId(
          this.parent.id
        ).evaluate(application);

        const required = !!(result & RulesetResult.REQUIRED);

        // Check if the value is null, undefined, or an empty string
        // Zero is a valid value, so we don't need to check for that
        if (
          required &&
          (value === null || value === undefined || value === '')
        ) {
          return this.createError({
            message: principalRent.requiredErrorMsg,
          });
        }
        return true;
      },
    });
  }
}
export default new Validation(new PrincipalRentValidation());
